import { withAlpha } from 'utils/colorUtils';

export default function CssBaseline(theme) {
  const thumbColor = withAlpha(theme.vars.palette.secondary.main, 0.42);
  const thumbHoverColor = withAlpha(theme.vars.palette.secondary.dark, 0.62);
  const trackColor = withAlpha(theme.vars.palette.secondary.light, 0.16);

  return {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollbarWidth: 'thin',
          scrollbarColor: `${thumbColor} ${trackColor}`
        },
        body: {
          scrollbarWidth: 'thin',
          scrollbarColor: `${thumbColor} ${trackColor}`
        },
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: `${thumbColor} ${trackColor}`
        },
        '*::-webkit-scrollbar': {
          width: 10,
          height: 10
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: thumbColor,
          borderRadius: 999,
          border: '2px solid transparent',
          backgroundClip: 'padding-box'
        },
        '*::-webkit-scrollbar-thumb:hover': {
          backgroundColor: thumbHoverColor
        },
        '*::-webkit-scrollbar-track': {
          backgroundColor: trackColor,
          borderRadius: 999
        },
        '*::-webkit-scrollbar-corner': {
          backgroundColor: 'transparent'
        }
      }
    }
  };
}
